import React, { useState, useEffect } from 'react';

const PASS = import.meta.env.VITE_DEMO_PASSWORD || 'clearequal2026';
const KEY = 'clearequal.demo.unlocked';

export default function DemoGate({ children }) {
  const [ok, setOk] = useState(false);
  const [val, setVal] = useState('');
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY) === '1') setOk(true);
  }, []);

  const submit = (e) => {
    e.preventDefault();
    if (val === PASS) {
      sessionStorage.setItem(KEY, '1');
      setOk(true);
    } else {
      setErr(true);
      setVal('');
    }
  };

  if (ok) return children;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0F172A', fontFamily: 'system-ui, sans-serif', padding: 20 }}>
      <form onSubmit={submit} style={{ background: '#fff', borderRadius: 16, padding: 40, width: '100%', maxWidth: 380, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: '#1E2761', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ width: 13, height: 13, borderRadius: '50%', border: '2.5px solid #E8963A' }} />
          </div>
          <span style={{ fontWeight: 700, fontSize: 18, color: '#1E2761' }}>ClearEqual</span>
        </div>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: '#0F172A', margin: '12px 0 6px' }}>Private access</h1>
        <p style={{ fontSize: 14, color: '#64748B', margin: '0 0 20px', lineHeight: 1.5 }}>This environment is password protected. Enter the access password to continue.</p>
        <input
          type="password"
          autoFocus
          value={val}
          onChange={(e) => { setVal(e.target.value); setErr(false); }}
          placeholder="Access password"
          style={{ width: '100%', padding: '12px 14px', fontSize: 15, borderRadius: 10, border: err ? '1.5px solid #D0433B' : '1.5px solid #E4E6EE', outline: 'none', background: err ? '#FBEAE9' : '#F7F7FB', boxSizing: 'border-box' }}
        />
        {err && <div style={{ color: '#D0433B', fontSize: 13, marginTop: 8 }}>Incorrect password.</div>}
        <button type="submit" style={{ width: '100%', marginTop: 16, padding: 12, fontSize: 15, fontWeight: 600, color: '#fff', background: '#1E2761', border: 'none', borderRadius: 10, cursor: 'pointer' }}>Enter</button>
      </form>
    </div>
  );
}
